export default __webpack_public_path__ + "static/media/dashboard-1.3e4c15c0.png";